/**
 * MechaGuard - EconomySystem (经济系统)
 *
 * 集中管理金币收支，任何变动都通过 onChange 回调通知 UI，
 * 避免在多处直接修改 UI 数值导致显示不同步。
 */

export class EconomySystem {
  /** @param {number} [initialGold=200] */
  constructor(initialGold = 200) {
    this.gold = initialGold;
    this.totalEarned = 0;
    this.totalSpent = 0;

    /** @type {((gold:number, delta:number)=>void)|null} */
    this.onChange = null;
  }

  /** 是否买得起 */
  canAfford(amount) {
    return this.gold >= amount;
  }

  /**
   * 扣款
   * @returns {boolean} 成功与否（余额不足时返回 false 且不扣款）
   */
  spend(amount) {
    if (amount < 0 || !this.canAfford(amount)) return false;

    this.gold -= amount;
    this.totalSpent += amount;
    this._emit(-amount);
    return true;
  }

  /** 收入 */
  earn(amount) {
    if (!(amount > 0)) return;

    this.gold += amount;
    this.totalEarned += amount;
    this._emit(amount);
  }

  /** 直接设置余额（重开游戏用） */
  set(amount) {
    const delta = amount - this.gold;
    this.gold = amount;
    this._emit(delta);
  }

  _emit(delta) {
    if (this.onChange) this.onChange(this.gold, delta);
  }
}
